export const genderOptions = [
  { id: 0, value: 'Мужской' },
  { id: 1, value: 'Женский' },
];
